import { useEffect, useState } from 'react'

import { useGetTrackedProcessesListQuery } from '../../../../app/apiSlice'
import { InlineLoader } from '../../../../common/components'
import { Tabs, Text } from '../../../../common/designs'
import InsightCard from '../../../Insights/InsightCard'
import InsightModal from '../../../Insights/InsightsModal'
import { Insight } from '../../../Insights/types'
import { INSIGHT_TABS, getInsights } from './insightData'

const InsightsSection = () => {
  const [tabSelected, setTabSelected] = useState<string>(INSIGHT_TABS[0].value)
  const [insightData, setInsightData] = useState<Insight[]>([])
  const [insightChosenForInspection, setInsightChosenForInspection] = useState<any>()

  const { data: trackedProcesses, isLoading } = useGetTrackedProcessesListQuery()

  const isInsightModalOpen = Boolean(insightChosenForInspection)

  useEffect(() => {
    if (trackedProcesses) {
      setInsightData(
        getInsights(
          trackedProcesses.map((process) => process.id),
          tabSelected,
        ),
      )
    }
  }, [trackedProcesses, tabSelected])

  return (
    <div className='my-4 flex w-full flex-col gap-2'>
      <div>
        <Text size='l' weight={600}>
          What do you want to focus on first?
        </Text>

        <Text size='s'>Select type of insight you wish to inspect.</Text>
      </div>
      {isLoading && <InlineLoader />}
      {!isLoading && tabSelected && (
        <>
          <Tabs size='xs' options={INSIGHT_TABS} value={tabSelected} onChange={setTabSelected} />
          <div className='grid grid-cols-2 gap-3 lg:grid-cols-3 2xl:grid-cols-4'>
            {insightData.map((insight) => {
              const { id, title, types } = insight

              return (
                <InsightCard
                  key={id}
                  title={title}
                  types={types}
                  onClick={() => setInsightChosenForInspection(insight)}
                />
              )
            })}
          </div>
        </>
      )}

      {isInsightModalOpen && (
        <InsightModal
          open={isInsightModalOpen}
          onClose={() => setInsightChosenForInspection(null)}
          title={insightChosenForInspection.title}
          description={insightChosenForInspection.description}
          solution={insightChosenForInspection.solution}
          imageUrl={insightChosenForInspection.image_url}
          imageAlt={insightChosenForInspection.image_alt}
          href={insightChosenForInspection.href}
          types={insightChosenForInspection.types}
        />
      )}
    </div>
  )
}

export default InsightsSection

